import React from 'react';
import { Props as LinkProps, Link } from 'ha/ui.legacy/Link';
import { useIntl } from 'ha/i18n';

interface Props {
  children: React.ReactNode;
  city?: { name?: string };
  country?: { name?: string };
}

const LinkToSearch: React.FC<Props & Omit<LinkProps, 'to'>> = ({
  city,
  country,
  children,
  ...rest
}) => {
  const { urlResolver } = useIntl();
  const searchLink = React.useMemo(() => {
    if (city && city.name && country && country.name) {
      return urlResolver.getSearchUrl(city.name, country.name);
    }
    return urlResolver.getBaseUrl();
  }, [city, country, urlResolver]);

  return (
    <Link
      data-test-locator="Link To Search"
      skipLangFormat
      to={searchLink}
      {...rest}
    >
      {children}
    </Link>
  );
};

export { LinkToSearch };
